import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";
import { StatusBadge, STATUS_ORDER, STATUS_LABELS } from "@/pages/admin/adminUi";

export default function Applications() {
  const [params, setParams] = useSearchParams();
  const status = params.get("status") || "";
  const [apps, setApps] = useState(null);

  useEffect(() => {
    api.get("/admin/applications", { params: status ? { status } : {} }).then((r) => setApps(r.data.applications));
  }, [status]);

  return (
    <div data-testid="admin-applications">
      <div className="mb-8 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <div>
          <p className="text-[11px] tracking-[0.3em] uppercase text-gold">Selection Pipeline</p>
          <h1 className="mt-3 font-serif font-light text-4xl text-ivory">Applications</h1>
        </div>
      </div>

      <div className="flex flex-wrap gap-2 mb-8">
        <button onClick={() => setParams({})} className={`px-4 py-2 text-[10px] tracking-[0.18em] uppercase border transition-colors ${!status ? "border-gold text-gold" : "border-ivory/20 text-ivory/50 hover:border-ivory/50"}`} data-testid="filter-all">All</button>
        {STATUS_ORDER.map((s) => (
          <button key={s} onClick={() => setParams({ status: s })} className={`px-4 py-2 text-[10px] tracking-[0.18em] uppercase border transition-colors ${status === s ? "border-gold text-gold" : "border-ivory/20 text-ivory/50 hover:border-ivory/50"}`} data-testid={`filter-${s}`}>{STATUS_LABELS[s]}</button>
        ))}
      </div>

      {apps === null ? (
        <p className="text-ivory/40 text-sm py-12">Loading…</p>
      ) : apps.length === 0 ? (
        <div className="border border-ivory/10 bg-navy-800 p-16 text-center">
          <p className="font-serif italic text-2xl text-ivory/60">No applications {status ? "in this stage" : "yet"}.</p>
        </div>
      ) : (
        <div className="border border-ivory/10 divide-y divide-ivory/10">
          {apps.map((a) => (
            <Link key={a.id} to={`/admin/applications/${a.id}`} className="grid grid-cols-12 gap-4 items-center px-5 py-5 bg-navy-800 hover:bg-navy-700 transition-colors group" data-testid={`app-row-${a.id}`}>
              <div className="col-span-12 md:col-span-5">
                <p className="font-serif text-xl text-ivory group-hover:text-gold transition-colors flex items-center gap-2">
                  {a.property?.name || "Untitled Property"}
                  {a.founding_member && <span className="text-[8px] tracking-widest uppercase text-gold border border-gold/40 px-2 py-0.5">Founding</span>}
                </p>
                <p className="text-ivory/45 text-xs mt-1">{[a.property?.city, a.property?.location].filter(Boolean).join(", ")}</p>
              </div>
              <div className="col-span-6 md:col-span-3 text-ivory/55 text-sm">{a.management?.contact_name}</div>
              <div className="col-span-4 md:col-span-2"><StatusBadge status={a.status} /></div>
              <div className="col-span-2 md:col-span-2 text-right text-ivory/35 text-xs flex items-center justify-end gap-2">
                {(a.created_at || "").slice(0, 10)}
                <ArrowUpRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity text-gold" />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
